module.exports = __webpack_public_path__ + "img/home-logo.a0ba150f.png";